import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from "../Footer";

const Upgrade = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("monthly");
  const [analyzedPlans, setAnalyzedPlans] = useState(null);

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  const storedUserPreferences = getDataFromlocalStorage("userData");

  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        confirmButtonText: "Back To Home",
      }).then(() => {
        navigate("/");
      });
      return;
    }

    const fetchAnalyzedPlans = async () => {
      try {
        const response = await fetch(
          window.CARLOCA_API + "/analyze-plans",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              user_id: storedUserPreferences.id,
              plans: plans,
            }),
          }
        );
        const data = await response.json();
        if (data.status) {
          setAnalyzedPlans(data);
        }
      } catch (error) {
        console.error("Failed to analyze plans:", error);
      }
    };

    fetchAnalyzedPlans();
  }, []);

  const navigateToCheckout = (plan) => {
    const user_id = storedUserPreferences?.id ?? null;
    navigate("/dealer/checkout", { state: { plan } });
  };

  const handleToggle = () => {
    setSelectedPlan(selectedPlan === "monthly" ? "yearly" : "monthly");
  };

  const plans = {
    monthly: [
      {
        price_id: "price_1RrMbZSDfxALB3T3u133MxOB",
        product_id: "prod_SEOwpr9Kss4B7A",
        code: "basic_monthly_plan",
        period: "month",
        interval: "monthly",
        highlight: false,
        name: "Dealer Basic",
        price: "40",
        vat: 40 * 0.20,
        trial_days: "7",
        carLimit: 50,
        subtext:
          "Get started with an entry level advertising plan for your dealership.",
        features: ["1-50", "Dealer Dashboard"],
      },
      {
        price_id: "price_1RJwHASDfxALB3T3SWOdn2NS",
        product_id: "prod_SEP5T1luhnJUwt",
        code: "standard_monthly_plan",
        period: "month",
        interval: "monthly",
        highlight: true,
        name: "Dealer Standard",
        price: "75",
        vat: 75 * 0.20,
        trial_days: "7",
        carLimit: 150,
        subtext:
          "Advertise all your inventory at a great price. Fits most business models.",
        features: ["51-150", "Dealer Dashboard", "Dealer to Dealer Messaging"],
      },
      {
        price_id: "price_1RrMSnSDfxALB3T3YQ6efPgY",
        product_id: "prod_SEP7YmLk1ObXlr",
        code: "unlimited_monthly_plan",
        period: "month",
        interval: "monthly",
        highlight: false,
        name: "Unlimited",
        price: "135",
        vat: 135 * 0.20,
        trial_days: "7",
        carLimit: 1000,
        subtext: "It offers exactly what it says. Unlimited car listings!",
        features: [
          "Unlimited Car Listing",
          "Dealer Dashboard",
          "Dealer to Dealer Messaging",
          "Detailed Reporting",
          "3rd Party Software Integration",
        ],
      },
    ],
    yearly: [
      {
        price_id: "price_1RrMaFSDfxALB3T3qJU6hRYr",
        product_id: "prod_SEOwpr9Kss4B7A",
        code: "basic_yearly_plan",
        period: "year",
        interval: "yearly",
        highlight: false,
        name: "Dealer Basic",
        price: "440",
        vat: 440 * 0.20,
        trial_days: "7",
        carLimit: 50,
        subtext:
          "Get started with an entry level advertising plan for your dealership.",
        features: ["1-50", "Dealer Dashboard"],
      },
      {
        price_id: "price_1RrMW7SDfxALB3T3cp7NzyvJ",
        product_id: "prod_SEP5T1luhnJUwt",
        code: "standard_yearly_plan",
        period: "year",
        interval: "yearly",
        highlight: true,
        name: "Dealer Standard",
        price: "825",
        vat: 825 * 0.20,
        trial_days: "7",
        carLimit: 150,
        subtext:
          "Advertise all your inventory at a great price. Fits most business models.",
        features: ["51-150", "Dealer Dashboard", "Dealer to Dealer Messaging"],
      },
      {
        price_id: "price_1RrMQRSDfxALB3T3lR7FNrGA",
        product_id: "prod_SEP7YmLk1ObXlr",
        code: "unlimited_yearly_plan",
        period: "year",
        interval: "yearly",
        highlight: false,
        name: "Unlimited",
        price: "1485",
        vat: 1485 * 0.20,
        trial_days: "7",
        carLimit: 1000,
        subtext: "It offers exactly what it says. Unlimited car listings!",
        features: [
          "Unlimited Car Listing",
          "Dealer Dashboard",
          "Dealer to Dealer Messaging",
          "Detailed Reporting",
          "3rd Party Software Integration",
        ],
      },
    ]
  };

  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between flex-wrap w-100 mb-4 gap-2">
            <div>
              <h3 className="cl-page-title">Trusted Cars Plans</h3>
              <p className="cl-page-subtitle">Upgrade or downgrade your dealer plan</p>
            </div>
            <Link to="/dealer/dashboard" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left me-1"></i>Back
            </Link>
          </div>

          <div className="card shadow-0 rounded-0 p-2 py-4 mt-5">
            <div className="row justify-content-center">
              <div className="col-md-6 mb-5">
                <h1 className="fs-3 fw-bold text-center">Find Your Perfect Dealer Plan</h1>
                <p className="text-center " style={{ fontWeight: "100" }}>
                  Discover the ideal plan to fuel your business growth. Our pricing options are carefully crafted to cater to car advertising needs.
                </p>
                <div className="toggle-container">
                  <div
                    className={`toggle-btn ${selectedPlan === "monthly" ? "monthly" : "yearly"}`}
                    onClick={handleToggle}
                  >
                    <span className={`toggle-text ${selectedPlan === "monthly" ? "active" : ""}`}>Monthly</span>
                    <span className={`toggle-text ${selectedPlan === "yearly" ? "active" : ""}`}>Yearly</span>
                  </div>
                </div>
              </div>

              {analyzedPlans?.current_plan && (
                <div className="col-md-12 text-center mb-3">
                  <div className="alert alert-info">
                    Current Plan: {analyzedPlans.current_plan.interval} â€“ Â£{analyzedPlans.current_plan.price} â€“ {analyzedPlans.current_plan.remaining_days} days left
                  </div>
                </div>
              )}

              <div className="col-md-11">
                <div className="row justify-content-center">
                  {analyzedPlans &&
                    analyzedPlans.plans
                      .filter((plan) => {
                        const current = analyzedPlans?.current_plan;
                        if (!current?.stripe_id || current?.interval === "free" || current?.interval === "trial") {
                          return plan.interval === selectedPlan;
                        }
                        return plan.interval === current.interval && plan.interval === selectedPlan;
                      })
                      .map((plan, index) => (
                        <div className="col-md-4 mt-3" style={{ minHeight: "34rem" }} key={plan.price_id}>
                          <div className={`card h-100 plancard ${plan?.highlight ? "active" : ""}`}>
                            <div className="card-body position-relative">
                              <h4 className="fs-4 fw-bold plan_heading">{plan.name}</h4>
                              <p className="fw-lighter subtext">{plan.subtext}</p>
                              <div>
                                <span className="plan_price fs-5 me-2 fw-bolder">Â£{plan.price}</span>
                                <br />
                                <span className="month">+ Â£{plan.vat} VAT</span>
                                <br />
                                <span className="plan_price fs-3 me-2 fw-bolder">
                                  Â£{parseInt(plan.price) + plan.vat} <span className="fs-6">/ per {selectedPlan}</span>
                                </span>
                              </div>
                              <hr />
                              <ul className="list-unstyled">
                                {plan.features?.map((feature, i) => (
                                  <li key={i} className="list-group-item mt-2">
                                    <i className="fa fa-check me-2"></i>
                                    {feature}
                                  </li>
                                ))}
                              </ul>
                              {plan.type === "current" && (
                                <span className="badge bg-primary mb-2">Your Current Plan</span>
                              )}

                              {plan.type !== "current" && (
                                <span
                                  className={`badge mb-2 ${plan.interval !== analyzedPlans?.current_plan?.interval
                                      ? "bg-info text-dark"
                                      : plan.type === "upgrade"
                                        ? "bg-success"
                                        : "bg-warning text-dark"
                                    }`}
                                >
                                  {plan.interval !== analyzedPlans?.current_plan?.interval
                                    ? `New Plan â€“ Pay Â£${parseFloat(plan.payable).toFixed(2)}`
                                    : `${plan.type.toUpperCase()} â€“ Pay Â£${parseFloat(plan.payable).toFixed(2)}`}
                                </span>
                              )}





                              <button
                                onClick={() => navigateToCheckout(plan)}
                                className="btn btn-outline-primary mx-auto position-absolute"
                                style={{ width: "90%", bottom: "5%", transform: "translate(-50%)", left: "50%" }}
                                disabled={plan.type === "current"}
                              >
                                {plan.type === "current"
                                  ? "Current Plan"
                                  : plan.type === "upgrade"
                                    ? "Upgrade Now"
                                    : plan.type === "downgrade"
                                      ? "Downgrade"
                                      : "Get Started"}
                              </button>

                            </div>
                          </div>
                        </div>
                      ))}
                </div>
              </div>

              <div className="col-md-6 mt-3">
                <p className="text-center" style={{ fontSize: "13px" }}>
                  If your listing requirements have changed then you can easily upgrade or downgrade your plan to accommodate the number of cars you need to list.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Upgrade;
